import { render } from "./BaseNumberInput.vue?vue&type=template&id=51317d84&ts=true"
import script from "./BaseNumberInput.vue?vue&type=script&lang=ts"
export * from "./BaseNumberInput.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__